import React, { useEffect, useState } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import Wrapper from '../../../components/Wrapper/Wrapper';
import { tripTableHeight, tableHeightWithSparkline, tableHeightWithSparklineSingle } from "../../../../styleVariables";
import { connect } from "react-redux";
import TopCard from '../../../components/TopCard/TopCard';
import TapLayout from '../../../components/PageLayout/TabLayOut';
import Grid from '@material-ui/core/Grid';
import MUIDataTable from "mui-datatables";
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import { getSinglePartyLedgerData, getSinglePartyPDFReport } from '../../../../store/actions/homeActionCreator';
import { getTripSparkLine, getPartyPayments,getPartyCompanyDetails,getPartySettings,updatePartySettings } from '../../../../store/actions/partiesActionCreator';
import { numberFormat, getTripStartDateFilterValues, getDateInStringDDMMMYYYY, getRequestTimeInMillis } from "../../../../utils/utils";
import {
  TRIP_ACTIONS,
  TRIP_STATUS_DIALOG_TITLES,
  TRIP_STATUS_DIALOG_LABELS,
  TRIP_FILTER_STATUS,
  TRIP_FILTER_STATUS_MAPPING,
  PAYMENT_CHIPS,
  TRIP_STATUS_LABELS,
  TRIP_TRANSACTION_FILTER,
  TRIP_TRANSACTION_FILTER_LIST
} from "../../../../store/constants";
import { trackEvent } from '../../../../analytics';
import useStyles from '../../css/partyprofile';
import ListSubheader from '@material-ui/core/ListSubheader';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import ActionButton from '../../../components/Actions/ActionButton';
import ColumnActions from '../../../components/Actions/ColumnActions';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import Button from '@material-ui/core/Button';
import ReportsDialog from '../../../components/ReportsDialog/ReportsDialog';
import PaymentTabFilter from '../../../components/FilterComponent/PaymentTabFilter';
import DateFilter from '../../../components/FilterComponent/DateFilter';
import * as logger from "../../../../logger";
import { createMuiTheme,withStyles } from "@material-ui/core/styles";
import Paper from '@material-ui/core/Paper';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import AddPartyCompanyDetails from '../../../components/Party/AddPartyCompanyDetails'
import Divider from '@material-ui/core/Divider';
import MenuItem from '@material-ui/core/MenuItem';
import AddAlertIcon from '@material-ui/icons/AddAlert';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';

import {
  TextField,
  Checkboxes,
  Radios,
  //Select,
  DatePicker,
  TimePicker,
  Autocomplete,
  Switches
} from 'mui-rff';

const theme = createMuiTheme({
  // MUIDataTableToolbar: {
  //   root: {
  //     display: 'block'
  //   }
  // }
});
const AntSwitch = withStyles((theme) => ({
  root: {
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
  },
  switchBase: {
    padding: 2,
    color: theme.palette.grey[500],
    '&$checked': {
      transform: 'translateX(12px)',
      color: theme.palette.common.white,
      '& + $track': {
        opacity: 1,
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
      },
    },
  },
  thumb: {
    width: 12,
    height: 12,
    boxShadow: 'none',
  },
  track: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: theme.palette.common.white,
  },
  checked: {},
}))(Switch);

const PartyProfileTab = ({ user, location,dispatchUpdateSettings, parties,dispatchGetCompanyDetails,dispatchGetSettings }) => {

  const [pdfOpen, setPdfOpen] = useState(false);
  const [changeFlag, setChangeFlag] = useState(false);
  const [sendSMS,setSendSMS] = useState(parties && parties.settings && parties.settings.sendSMSToParty?parties.settings.sendSMSToParty:false);
  const [shareBank,setShareBank] = useState(parties && parties.settings && parties.settings.shareBank?parties.settings.shareBank:false);
  const [remainder,setRemainder] = useState(parties && parties.settings && parties.settings.reminderIndex?parties.settings.reminderIndex:0);
  const [addPartyCompanyDetailsOpen, setAddPartyCompanyDetailsOpen] = useState(false);
  const [remainders,setRemainders] = useState(parties && parties.settings && parties.settings.reminderConfig?parties.settings.reminderConfig:[])
  let history = useHistory();
  const classes = useStyles();
  let path = location && location.pathname ? location.pathname.split("/") : [];
  let partId = "";
  if (path[path.length - 1]) {
    partId = path[path.length - 1];
  }
  const getSettings =  ()=>{
    dispatchGetSettings(partId,(response)=>{
      if(response && response.status && response.status && response.status.code && response.status.code=== 200){
        setRemainders(response.response.reminderConfig);
        setRemainder(parties && parties.settings && parties.settings.reminderIndex?parties.settings.reminderIndex:0)
      }
    },()=>{

    })
  }
  const updateSettings = async (data)=>{
    /*let rem = remainders && remainder && remainders[remainder]?remainders[remainder]:remainders[0];
    let data = {
      customerId:partId,
      sendSMSToParty:sendSMS,
      shareBankDetails:shareBank,
      reminderDuration:rem && rem.value&&rem.value.count?rem.value.count:null,
      reminderDurationUnit:rem && rem.value&&rem.value.unit?rem.value.unit:null
    }*/
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
    await sleep(300);
    if (data && data.reminderIndex) {
      delete data['reminderIndex']; 
    }
    dispatchUpdateSettings(data,(response)=>{
      if(response && response.status && response.status && response.status.code && response.status.code=== 200){
        getSettings();
      }
    },()=>{

    })
  }
  useEffect(() => {
    getSettings()
  }, [])
  const handleAddPartyCompanyDetailsOpen = (status) => {
    dispatchGetCompanyDetails(partId,(response)=>{
      if(response && response.status && response.status && response.status.code && response.status.code=== 200){
        setAddPartyCompanyDetailsOpen(true)
      }
    },()=>{

    })
  };
  const handleAddPartyCompanyDetailsClose = (status) => {
    setAddPartyCompanyDetailsOpen(false)
  };
  const handleAddPartyCompanyDetailsSave = (status) => {
    setAddPartyCompanyDetailsOpen(false)
  };
  const handleSendSms = ()=>{
    //setSendSMS(!sendSMS)
    let data = {
      ...parties.settings,
      customerId:partId,
      sendSMSToParty:!parties.settings.sendSMSToParty
    }
    updateSettings(data)
  }
  const handleShareBank = ()=>{
    //setShareBank(!shareBank)
    let data = {
      ...parties.settings,
      customerId:partId,
      shareBankDetails:!parties.settings.shareBankDetails
    }
    updateSettings(data)
  }
  const handleRemainder = (e)=>{
    //setRemainders(e.target.value);
    let rem = remainders && e.target.value && remainders[e.target.value]?remainders[e.target.value]:remainders[0];
    let data = {
      ...parties.settings,
      customerId:partId,
      reminderDuration:rem && rem.value&&rem.value.count?rem.value.count:null,
      reminderDurationUnit:rem && rem.value&&rem.value.unit?rem.value.unit:null
    }
    updateSettings(data);
  }
  return (<>
    <TapLayout>
      <div className={classes.pageContentDIv}>
      <Grid container spacing={3}>
        <Grid item xs={8}>
          <Paper className={classes.paper}>
            <List>
              <ListItem button onClick={handleAddPartyCompanyDetailsOpen}>
                <ListItemText 
                  primary="GST, PAN and Address" 
                  secondary="Tap to add or Edit GST, PAN or Address"
                  primaryTypographyProps={{
                    className:classes.gstAdd
                  }}
                  secondaryTypographyProps={{
                    className:classes.gstSecondary
                  }}
                />
                <ArrowForwardIosIcon className={classes.forwardIcon} />
              </ListItem>
            </List>
          </Paper>
        </Grid>
        <Grid item xs={8}>
          <List subheader={
              <ListSubheader component="div" id="party-settings-list-subheader" className={classes.settings}>
                SETTTINGS
              </ListSubheader>
          }/>
          <Paper className={classes.paper}>
            <List>
              {/* <ListItem>
                <ListItemText 
                  primary="Send SMS" 
                  secondary="Send SMS to the party for new Trips and Payments"
                  primaryTypographyProps={{
                    className:classes.gstAdd
                  }}
                  secondaryTypographyProps={{
                    className:classes.gstSecondary
                  }}
                />
                <AntSwitch checked={parties && parties.settings && parties.settings.sendSMSToParty?parties.settings.sendSMSToParty:false} onChange={handleSendSms} name="sendSMS" />
              </ListItem>
              <Divider /> */}
              <ListItem>
                <ListItemText 
                  primary="Include bank account details" 
                  secondary="Include bank account details while sharing PDF"
                  primaryTypographyProps={{
                    className:classes.gstAdd
                  }}
                  secondaryTypographyProps={{
                    className:classes.gstSecondary
                  }}
                />
                <AntSwitch checked={parties && parties.settings && parties.settings.shareBankDetails?parties.settings.shareBankDetails:false} onChange={handleShareBank} name="shareBank" />
              </ListItem>
              <Divider />
              <ListItem>
                <ListItemText 
                  primary={
                    <>
                      <div className={classes.reminderInput}>
                        <div>
                          <AddAlertIcon className={classes.reminderIcon} />
                        </div>
                        <div>
                          Reminde Me
                        </div>
                        <div className={classes.selectDiv}>
                          {parties && parties.settings && parties.settings.reminderConfig && <Select
                                name="remainder_value"
                                variant="outlined"
                                //label={''}
                                notched
                                value={parties && parties.settings && parties.settings.reminderIndex?parties.settings.reminderIndex:0}
                                labelWidth={0}
                                onChange={handleRemainder}
                                placeholder={''}
                                margin='none'
                                size='small'
                                fullWidth={false}
                                labelWidth={0}
                                className={classes.reminderselect}
                              >
                                {parties.settings.reminderConfig.map((type,index)=>{
                                    return (<MenuItem key={index} value={index}>{type.display}</MenuItem>);
                                })}
                                
                          </Select>}
                        </div>
                        <div>
                          After POD is submitted
                        </div>
                      </div>
                    </>
                  }
                  primaryTypographyProps={{
                    className:classes.gstAdd
                  }}
                />
              </ListItem>
            </List>
          </Paper>
        </Grid>
      </Grid>
      </div>
      {addPartyCompanyDetailsOpen && <AddPartyCompanyDetails  sideBarOpen={addPartyCompanyDetailsOpen} sideBarClose={handleAddPartyCompanyDetailsClose} onSave={handleAddPartyCompanyDetailsSave}  />}
    </TapLayout>
  </>)
};
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchGetSinglePartyTripSparkLine: (requestData, onSuccess, onFailure) => dispatch(getTripSparkLine(requestData, onSuccess, onFailure)),
  dispatchGetSinglePartyPayments: (requestData, onSuccess, onFailure) => dispatch(getPartyPayments(requestData, onSuccess, onFailure)),
  dispatchGetCompanyDetails:(partyId,onSuccess,onFailure)=>(dispatch(getPartyCompanyDetails(partyId,onSuccess,onFailure))),
  dispatchGetSettings:(partyId,onSuccess,onFailure)=>(dispatch(getPartySettings(partyId,onSuccess,onFailure))),
  dispatchUpdateSettings:(data,onSuccess,onFailure)=>(dispatch(updatePartySettings(data,onSuccess,onFailure)))
});
const PartyProfileTabWithRouter = withRouter(PartyProfileTab);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PartyProfileTabWithRouter);